import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M30.6 14.2L3.4.6A2 2 0 00.5 2.4v27.2a2 2 0 003 1.8l27.1-13.6a2 2 0 000-3.6z"
	})
});
export { SvgPlayTriangle as ReactComponent };
